import { AlertCircle } from "lucide-react";
import errorFallbackImage from "@/assets/images/error-fallback.png";

export type ErrorPageViewProps = {
  title: string
  description?: string
  onBackHome: () => void
  showSupportText?: boolean
};

export const ErrorPageView = ({
  title,
  description,
  onBackHome,
  showSupportText = true,
}: ErrorPageViewProps) => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-lightgray p-4 dark:bg-dark">
      <div className="w-full max-w-lg">
        <div className="mb-8 flex justify-center">
          <img
            src={errorFallbackImage}
            alt="Erreur"
            className="h-56 w-auto object-contain"
          />
        </div>

        <div className="overflow-hidden rounded-xl border border-border bg-white shadow-xl dark:border-darkborder dark:bg-dark">
          <div className="bg-lighterror/10 p-8 dark:bg-lighterror/5">
            <div className="flex flex-col items-center text-center">
              <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-error/10">
                <AlertCircle className="h-8 w-8 text-error" />
              </div>
              <h1 className="mb-3 text-3xl font-bold text-dark dark:text-white">
                {title}
              </h1>
              {description && (
                <p className="text-base text-muted dark:text-lightmuted">
                  {description}
                </p>
              )}
            </div>
          </div>

          <div className="pb-8 px-8">
            <button
              type="button"
              onClick={onBackHome}
              className="w-full rounded-lg bg-primary px-6 py-4 text-lg font-semibold text-white shadow-sm transition-colors hover:bg-primary-emphasis focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 dark:focus:ring-offset-dark"
            >
              Retour à l'accueil
            </button>

            {showSupportText && (
              <p className="mt-6 text-center text-sm text-muted dark:text-lightmuted">
                Si le problème persiste, contactez le support technique.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

ErrorPageView.displayName = "ErrorPageView";
